export const projects = [
  {
    id: 1,
    name: 'Rock-Paper-Scissors Game',
    tagline: 'An interactive twist on the classic game, enhanced with modern web technologies.',
    description: 'An interactive web application that brings the classic "Rock-Paper-Scissors" game to life, featuring both frontend and backend components.',
    points: [
      'Engaging user interface with responsive design.',
      'Real-time game logic processing.',
      'Score tracking and game history.',
      'RESTful API integration for game data management.',

    ],
    technologies: [
      { name: 'JavaScript', logo: '/logos/javascript.svg' },
      { name: 'React', logo: '/logos/react.svg' },
      { name: 'Tailwind CSS', logo: '/logos/tailwindcss.svg' },
      { name: 'HTML', logo: '/logos/html.svg' },
      { name: 'CSS', logo: '/logos/css.svg' },
      { name: 'Vite', logo: '/logos/vite.svg' }
    ],
    image: '/project_pics/rock-paper-scissors.png',
    accentShadow: '0 25px 74px 0 #d1c4e9',     
    gutterLight: '#D1B6FF', 
    gradient: 'from-pink-800 to-pink-400',
    accentColor: '#B084F8'
  },
  {
    id: 2,
    name: 'Puny URL',
    tagline: 'Simplifying web navigation with concise, reliable links.',
    description: 'Puny URL is a minimalistic and efficient URL shortener built with Node.js, Express, and SQLite. This application allows users to shorten long URLs and redirect to the original URLs using the generated short codes.',
    points: [
      'Generate short URLs for any valid long URL.',
      'Redirect short URLs to their original destinations.',
      'Simple and intuitive frontend interface.',
      'Lightweight backend using SQLite for storage.',
    ],
    technologies: [
      { name: 'JavaScript', logo: '/logos/javascript.svg' },
      { name: 'React', logo: '/logos/react.svg' },
      { name: 'Node.js', logo: '/logos/nodejs.svg' },
      { name: 'MongoDB', logo: '/logos/mongodb.svg' },
      { name: 'Tailwind CSS', logo: '/logos/tailwindcss.svg' },
      { name: 'Express', logo: '/logos/express.svg' },
      { name: 'HTML', logo: '/logos/html.svg' },
      { name: 'CSS', logo: '/logos/css.svg' },
      { name: 'SQLite', logo: '/logos/sqlite.svg' }
    ],
    image: '/project_pics/puny-url.png',
    gradient: 'from-purple-900 to-violet-700',
    accentColor: '#B084F6',
    accentShadow: '0 25px 74px 0 #d1c4e9',     
    gutterLight: '#D1B6FF', 
  },
  {
    id: 3,
    name: 'Linux Commands',
    tagline: 'Bringing essential UNIX utilities to the Node.js environment.',
    description: 'A lightweight command-line toolset built with Node.js, inspired by basic UNIX utilities. This project includes implementations of common commands like wc, head, tail, and ls.',
    points: [
      "wc: Word, line, and byte count of a file.",
      "head: Print the first N lines of a file.",
      "tail: Print the last N lines of a file.",
      "ls: List directory contents with optional flags for hidden files and detailed view.",
    ],
    technologies: [
      { name: 'JavaScript', logo: '/logos/javascript.svg' },
      { name: 'Node.js', logo: '/logos/nodejs.svg' },
      { name: 'Express', logo: '/logos/express.svg' },
      { name: 'HTML', logo: '/logos/html.svg' },
    ],
    image: '/project_pics/linux-commands.png',
    accentShadow: '0 25px 74px 0 #d1c4e9',     
    gutterLight: '#D1B6FF', 
    gradient: "from-purple-800 via-yellow-200 to-pink-500",
    accentColor: '#B084F8'
  },
  {
    id: 4,
    name: 'Social Media App',
    tagline: 'Building connections through a feature-rich social platform.',
    description: 'A comprehensive social media application backend developed using Node.js and Express.js. The project encompasses user authentication, post creation, and real-time interactions, laying the groundwork for a scalable social networking platform.',
    points: [
      "User authentication and session management.",
      "Post creation, editing, and deletion functionalities.",
      "Real-time notifications and messaging features.",
      "Scalable architecture supporting future frontend integration.",
    ],
    technologies: [
      { name: 'JavaScript', logo: '/logos/javascript.svg' },
      { name: 'Node.js', logo: '/logos/nodejs.svg' },
      { name: 'Express', logo: '/logos/express.svg' },
      { name: 'React', logo: '/logos/react.svg' },
      { name: 'HTML', logo: '/logos/html.svg' },
      { name: 'CSS', logo: '/logos/css.svg' },
      { name: 'SQLite', logo: '/logos/sqlite.svg' }
    ],
    image: '/project_pics/placeholder.png',
    accentShadow: '0 25px 74px 0 #d1c4e9',     
    gutterLight: '#D1B6FF', 
    gradient: "from-blue-800 to-teal-500",
    accentColor: '#B084F6'
  },
  {
    id: 4,
    name: 'Personal Portfolio',
    tagline: 'A digital showcase of my development journey, skills, and projects.',
    description: 'A sleek, responsive personal website designed to highlight my work, technical expertise, and professional experience. Built with React and styled using Tailwind CSS, the site reflects modern design principles and serves as a central hub for exploring my portfolio, resume, and contact details.',
    points: [
      "Crafted a clean and intuitive user interface with Tailwind CSS for seamless navigation.",
      "Implemented project filtering and dynamic content rendering using React.",
      "Responsive design ensures optimal experience across devices and screen sizes.",
    ],
    technologies: [
      { name: 'JavaScript', logo: '/logos/javascript.svg' },
      { name: 'React', logo: '/logos/react.svg' },
      { name: 'Tailwind CSS', logo: '/logos/tailwindcss.svg' },
      { name: 'HTML', logo: '/logos/html.svg' },
      { name: 'CSS', logo: '/logos/css.svg' },
    ],
    image: '/project_pics/portfolio.png',
    accentShadow: '0 25px 74px 0 #d1c4e9',     
    gutterLight: '#D1B6FF', 
    gradient: "from-teal-800 to-blue-400",
    accentColor: '#B084F6'
  },
  // {
  //   id: 5,
  //   name: 'Opinion Poll',
  //   tagline: 'Capturing collective opinions through dynamic polling.',
  //   description: 'A lightweight Node.js application that allows users to create, vote on, and view the results of opinion polls. This project is designed to demonstrate basic CRUD operations, database interactions, and RESTful API design using Express.js and MongoDB.',
  //   points: [
  //     "Create Polls: Define a question with multiple options.",
  //     "Vote on Polls: Submit a vote for a selected option.",
  //     "View Poll Results: Retrieve the current vote counts for each option.",
  //     "List All Polls: See all existing polls available.",
  //   ],
  //   technologies: [
  //     { name: 'JavaScript', logo: '/logos/javascript.svg' },
  //     { name: 'Node.js', logo: '/logos/nodejs.svg' },
  //     { name: 'Express', logo: '/logos/express.svg' },
  //     { name: 'MongoDB', logo: '/logos/mongodb.svg' },
  //     { name: 'React', logo: '/logos/react.svg' },
  //     { name: 'Tailwind CSS', logo: '/logos/tailwindcss.svg' },
  //     { name: 'HTML', logo: '/logos/html.svg' },
  //     { name: 'CSS', logo: '/logos/css.svg' },
  //   ],
  //   image: '/project_pics/',
  //   accentShadow: '0 25px 74px 0 #d1c4e9',     
  //   gutterLight: '#D1B6FF', 
  //   gradient: "from-yellow-700 to-purple-500",
  //   accentColor: '#B084F6'
  // },
];